import React from 'react';
import { EditButton, ShowButton } from '@refinedev/mui';
import { Stack } from '@mui/material';

interface ParticipantActionsProps {
  recordItemId: string;
}

export const ParticipantActions: React.FC<ParticipantActionsProps> = ({
  recordItemId,
}) => {
  return (
    <Stack direction="row" spacing={1}>
      <ShowButton hideText recordItemId={recordItemId} />
      <EditButton hideText recordItemId={recordItemId} />
    </Stack>
  );
};
